<header class="shadow-lg w-full bg-white">
  <nav class="relative">
    <div class="px-6 py-5 lg:px-8">
      <div class="flex flex-wrap items-center justify-between">
        <!-- Logo -->
        <dhp-header-logo></dhp-header-logo>

        <div class="flex-grow"></div>

        <!-- Desktop Navigation -->
        <dhp-desktop-nav [navItems]="navItems"></dhp-desktop-nav>

        <!-- Spacer -->
        <div class="flex-grow"></div>

        <!-- Desktop Actions -->
        <dhp-desktop-actions
          [currentLanguage]="currentLanguage()"
          (searchStateChange)="onSearchStateChange($event)"
          (languageChange)="selectLanguage($event)"
        ></dhp-desktop-actions>

        <!-- Hamburger button for mobile menu -->
        <div class="flex items-center lg:hidden">
          <button
            class="flex items-center text-gray-600 transition-colors duration-300 hover:text-gray-300"
            (click)="toggleMenu()"
            aria-label="Toggle menu"
          >
            <span class="mr-2 font-medium text-orange-500">{{
              'components.header.menu' | translate
            }}</span>
            <img
              class="h-6"
              src="assets/icons/menu_icon_orange.png"
              alt="Menu"
            />
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <dhp-mobile-menu
      [navItems]="navItems"
      (menuClose)="closeMenu()"
      (searchStateChange)="onSearchStateChange($event)"
    ></dhp-mobile-menu>

    <!-- Language Modal -->
    <dhp-language-modal
      [currentLanguage]="currentLanguage()"
      (languageChange)="selectLanguage($event)"
    ></dhp-language-modal>
  </nav>
</header>
